import { CurrencyAddress, CurrencyModel } from '@root/entities/currency/model'
import { Network } from '@root/entities/network/model'

export const getPathfinderAddress = (currency: CurrencyModel) => {
  if (currency.network !== Network.Solana) {
    return currency.address
  }
  if (CurrencyModel.isNativeOrWrapped(currency.network)(currency)) {
    return CurrencyAddress('11111111111111111111111111111111')
  }
  return currency.address
}
